// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-select-add {
  --bg: #eef3f7;
  --text: #1f1f1f;
  --muted: #6b6b6b;
  position: relative;
  /* ✅ important */
  z-index: 9998;
}

.user-select-add__box {
  display: flex;
  align-items: center;
  gap: 8px;

  background: var(--bg);
  border-radius: 6px;
  padding: 0 8px;
  min-height: 52px;
}

.user-select-add__inputWrap {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1 1 auto;
}

.user-select-add__input {
  width: 100%;
  min-width: 0;

  border: 0;
  outline: none;
  background: transparent;

  padding: 10px 6px;
  color: var(--text);
  font: inherit;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 17px;
}

.user-select-add__caret {
  width: 36px;
  height: 36px;
  border: 0;
  background: transparent;
  color: var(--muted);
  border-radius: 6px;
  cursor: pointer;

  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.user-select-add__plus {
  flex: 0 0 40px;
  width: 40px;
  height: 36px;

  border: 0;
  background: transparent;
  color: #1f1f1f;
  border-radius: 6px;
  cursor: pointer;

  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.user-select-add__caret:hover,
.user-select-add__plus:hover {
  background: rgba(0, 0, 0, 0.06);
}

.user-select-add__caret:active,
.user-select-add__plus:active {
  background: rgba(0, 0, 0, 0.10);
}

.user-select-add__caret:focus-visible,
.user-select-add__plus:focus-visible,
.user-select-add__input:focus-visible {
  outline: 2px solid rgba(0, 0, 0, 0.35);
  outline-offset: 2px;
}

.user-select-add__dropdown {
  position: absolute;
  /* ✅ overlay */
  left: 0;
  right: 0;
  top: calc(44px + 38px);
  /* box height + gap; adjust if needed */
  z-index: 9999;
  /* ✅ above other components */

  background: var(--bg);
  border-radius: 6px;
  padding: 6px;
  display: grid;
  gap: 4px;

  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);
}

.user-select-add__dropdown__noheader {
  position: absolute;
  /* ✅ overlay */
  left: 0;
  right: 0;
  top: calc(44px + 4px);
  /* box height + gap; adjust if needed */
  z-index: 9999;
  /* ✅ above other components */

  background: var(--bg);
  border-radius: 6px;
  padding: 6px;
  display: grid;
  gap: 4px;

  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);
}

.user-select-add__item {
  border: 0;
  background: transparent;
  border-radius: 6px;
  padding: 8px 10px;
  text-align: left;
  cursor: pointer;
  color: var(--text);
}

.user-select-add__item.is-active {
  background: rgba(0, 0, 0, 0.06);
}

.user-select-add__item.is-selected .user-select-add__itemTitle {
  font-weight: 700;
}

.user-select-add__itemTitle {
  font-size: 15px;
  line-height: 1.2;
}

.user-select-add__itemSub {
  margin-top: 2px;
  font-size: 15px;
  color: var(--muted);
}

.user-select-add__empty {
  padding: 10px;
  color: var(--muted);
  text-align: center;
  font-size: 13px;
}

.user-select-add__hint {
  margin-top: 5px;
  font-size: 14px;
  color: var(--muted);
  padding-left: 6px;
}

.user-select-add[aria-disabled="true"] {
  opacity: 0.6;
  pointer-events: none;
}

.user-select-add__header {
  font-size: 17px;
  font-weight: 700;
  color: #013868;
  margin-bottom: 15px;
}

.user-select-add__clear,
.user-select-add__plus {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: none;
    background: transparent;
    cursor: pointer;
    color: var(--icon-color, #555);
}

.user-select-add__clear:hover {
    color: #c62828;
}

.user-select-add__clear:disabled {
    opacity: 0.4;
    cursor: default;
}`, "",{"version":3,"sources":["webpack://./src/web/component/UserSelectAdd/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,SAAS;EACT,aAAa;EACb,uBAAuB;;EAEvB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;;EAEb,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;;EAEf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;;EAEZ,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;;EAEf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;;EAGE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,uCAAuC;EACvC,aAAa;EACb,6BAA6B;;EAE7B,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,QAAQ;;EAER,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,uCAAuC;EACvC,aAAa;EACb,6BAA6B;;EAE7B,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,QAAQ;;EAER,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB","sourcesContent":[".user-select-add {\r\n  --bg: #eef3f7;\r\n  --text: #1f1f1f;\r\n  --muted: #6b6b6b;\r\n  position: relative;\r\n  /* ✅ important */\r\n  z-index: 9998;\r\n}\r\n\r\n.user-select-add__box {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n\r\n  background: var(--bg);\r\n  border-radius: 6px;\r\n  padding: 0 8px;\r\n  min-height: 52px;\r\n}\r\n\r\n.user-select-add__inputWrap {\r\n  display: flex;\r\n  align-items: center;\r\n  min-width: 0;\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.user-select-add__input {\r\n  width: 100%;\r\n  min-width: 0;\r\n\r\n  border: 0;\r\n  outline: none;\r\n  background: transparent;\r\n\r\n  padding: 10px 6px;\r\n  color: var(--text);\r\n  font: inherit;\r\n\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  font-size: 17px;\r\n}\r\n\r\n.user-select-add__caret {\r\n  width: 36px;\r\n  height: 36px;\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--muted);\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.user-select-add__plus {\r\n  flex: 0 0 40px;\r\n  width: 40px;\r\n  height: 36px;\r\n\r\n  border: 0;\r\n  background: transparent;\r\n  color: #1f1f1f;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.user-select-add__caret:hover,\r\n.user-select-add__plus:hover {\r\n  background: rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.user-select-add__caret:active,\r\n.user-select-add__plus:active {\r\n  background: rgba(0, 0, 0, 0.10);\r\n}\r\n\r\n.user-select-add__caret:focus-visible,\r\n.user-select-add__plus:focus-visible,\r\n.user-select-add__input:focus-visible {\r\n  outline: 2px solid rgba(0, 0, 0, 0.35);\r\n  outline-offset: 2px;\r\n}\r\n\r\n.user-select-add__dropdown {\r\n  position: absolute;\r\n  /* ✅ overlay */\r\n  left: 0;\r\n  right: 0;\r\n  top: calc(44px + 38px);\r\n  /* box height + gap; adjust if needed */\r\n  z-index: 9999;\r\n  /* ✅ above other components */\r\n\r\n  background: var(--bg);\r\n  border-radius: 6px;\r\n  padding: 6px;\r\n  display: grid;\r\n  gap: 4px;\r\n\r\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);\r\n}\r\n\r\n.user-select-add__dropdown__noheader {\r\n  position: absolute;\r\n  /* ✅ overlay */\r\n  left: 0;\r\n  right: 0;\r\n  top: calc(44px + 4px);\r\n  /* box height + gap; adjust if needed */\r\n  z-index: 9999;\r\n  /* ✅ above other components */\r\n\r\n  background: var(--bg);\r\n  border-radius: 6px;\r\n  padding: 6px;\r\n  display: grid;\r\n  gap: 4px;\r\n\r\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);\r\n}\r\n\r\n.user-select-add__item {\r\n  border: 0;\r\n  background: transparent;\r\n  border-radius: 6px;\r\n  padding: 8px 10px;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  color: var(--text);\r\n}\r\n\r\n.user-select-add__item.is-active {\r\n  background: rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.user-select-add__item.is-selected .user-select-add__itemTitle {\r\n  font-weight: 700;\r\n}\r\n\r\n.user-select-add__itemTitle {\r\n  font-size: 15px;\r\n  line-height: 1.2;\r\n}\r\n\r\n.user-select-add__itemSub {\r\n  margin-top: 2px;\r\n  font-size: 15px;\r\n  color: var(--muted);\r\n}\r\n\r\n.user-select-add__empty {\r\n  padding: 10px;\r\n  color: var(--muted);\r\n  text-align: center;\r\n  font-size: 13px;\r\n}\r\n\r\n.user-select-add__hint {\r\n  margin-top: 5px;\r\n  font-size: 14px;\r\n  color: var(--muted);\r\n  padding-left: 6px;\r\n}\r\n\r\n.user-select-add[aria-disabled=\"true\"] {\r\n  opacity: 0.6;\r\n  pointer-events: none;\r\n}\r\n\r\n.user-select-add__header {\r\n  font-size: 17px;\r\n  font-weight: 700;\r\n  color: #013868;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.user-select-add__clear,\r\n.user-select-add__plus {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 36px;\r\n    height: 36px;\r\n    border: none;\r\n    background: transparent;\r\n    cursor: pointer;\r\n    color: var(--icon-color, #555);\r\n}\r\n\r\n.user-select-add__clear:hover {\r\n    color: #c62828;\r\n}\r\n\r\n.user-select-add__clear:disabled {\r\n    opacity: 0.4;\r\n    cursor: default;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
